import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import * as React from "react";
import { UitkButtonSize, UitkSecondaryButton } from "uitk-react-button";
import { UitkSpacing } from "uitk-react-spacing";
interface HotwireDealViewProp {
  label: string;
  buttonLink: string;
}

interface CommonButtonProps {
  icon: string;
  text: string;
  size: UitkButtonSize;
  href: string;
}

export const HotwireDealView: React.FC<HotwireDealViewProp> = ({ label, buttonLink }) => {
  const commonProps: CommonButtonProps = {
    icon: "today",
    text: label,
    size: UitkButtonSize.LARGE,
    href: buttonLink,
  };

  return (
    <Viewport>
      <ViewSmall>
        <UitkSpacing padding={{ inline: "unset" }} margin={{ blockstart: "one", blockend: "three" }}>
          <UitkSecondaryButton {...commonProps} tag="a" isFullWidth={true} />
        </UitkSpacing>
      </ViewSmall>
      <ViewLarge>
        <UitkSpacing margin={{ blockstart: "one", inlineend: "three" }}>
          <UitkSecondaryButton {...commonProps} tag="a" />
        </UitkSpacing>
      </ViewLarge>
    </Viewport>
  );
};
